// locale for turtle

import safeLoadLocale from '@cdo/apps/util/safeLoadLocale';

let locale = safeLoadLocale('turtle_locale');
module.exports = locale;
